import React, { useState, useContext } from "react";
import { ThemeContext } from "../utils/context";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";
import "../i18n";

const languages = [
    { code: "fr", label: "Français", flag: "https://flagpedia.net/data/flags/w1160/fr.webp" },
    { code: "en", label: "English", flag: "https://flagpedia.net/data/flags/w1160/gb.webp" },
    { code: "pt", label: "Português", flag: "https://flagpedia.net/data/flags/w1160/pt.webp" },
];

function Lang() {
    const { theme } = useContext(ThemeContext);
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const currentLang = languages.find((lang) => lang.code === i18n.language) || languages[0];

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    return (
        <div className="relative flex items-center sm:mr-6 text-left ">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center gap-1 md:px-1 py-0 border-4 sm:border-2 rounded-full md:rounded-md overflow-hidden transition-all duration-300 ${theme === 'light' ? 'border-gray-300 hover:bg-gray-300' : 'border-gray-700 hover:bg-gray-700'}`}
            >

                <img src={currentLang.flag} alt={currentLang.label} className='w-6 h-6 md:w-5 md:h-3 rounded-sm object-cover' />
                <span className="hidden md:block text-sm">{currentLang.label}</span>
                <ChevronDown className="w-4 h-4 hidden md:block" />
            </button>

            {isOpen && (
                <div className={`absolute top-8 -right-3 sm:right-0 w-12 md:w-32 py-1 md:py-0 rounded-lg shadow-lg z-10 border overflow-hidden ${theme === 'light' ? 'bg-white/80' : 'bg-black/80'}`}>
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            onClick={() => changeLanguage(lang.code)}
                            className={`flex items-center gap-2 w-full px-2 py-1 text-left ${theme === 'light' ? 'hover:bg-white' : 'hover:bg-gray-700'}`}
                        >
                            <img src={lang.flag} alt={currentLang.label} className='w-8 h-6 md:w-6 md:h-4 rounded-sm object-cover' />
                            <span className="hidden md:block">{lang.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Lang;
